import * as Yup from 'yup';

export const supportInquiry = Yup.object({
  email: Yup.string().email('Invalid email address'),
  message: Yup.string().required('Required'),
  sessionId: Yup.string().required('Required'),
});

export type TSupportInquiry = Yup.InferType<typeof supportInquiry>;
